import axios from "axios";

export async function getStoryIds(params) {
  return axios({
    url: `https://hacker-news.firebaseio.com/v0/${params.storyType}.json?print=pretty`,
    method: "get",
    params,
    errorTitle: "Get Hacker News stories failed",
    signal: params.controller?.signal
  });
}

export async function getStoryById(params) {
  return axios({
    url: `https://hacker-news.firebaseio.com/v0/item/${params.storyId}.json?print=pretty`,
    method: "get",
    params,
    errorTitle: "Get Hacker News story failed",
    signal: params.controller?.signal
  });
}
